<template>
  <div class="general-wrapper">
    <div class="header">
      <h2 class="qrw-heading-xl">{{ $t("changelog.title") }}</h2>
    </div>
    <div class="px-50">
      <!-- <ChangelogCard2
        image="https://qrwaiter.com.ua/userContent/portioned-dishes-update-1817-ua.jpg"
      />
      <ChangelogCard2 color="red" /> -->
      <div v-for="item in changelog" :key="item._id">
        <ChangelogCard2 class="single-changelog-card" :card="item" />
      </div>
    </div>
  </div>
</template>

<script>
import ChangelogCard from "@/components/changelog/ChangelogCard.vue";
import ChangelogCard2 from "@/components/changelog/ChangelogCard2.vue";

import ChangelogAPI from "@/api/changelog";

export default {
  data() {
    return {
      changelog: [],
    };
  },
  components: {
    ChangelogCard,
    ChangelogCard2,
  },
  mounted() {
    ChangelogAPI.getList()
      .then((data) => {
        this.changelog = data.changelog;

        this.$store.commit("resetNotificationsCount");
      })
      .catch(console.error);
  },
};
</script>

<style scoped>
.single-changelog-card {
  margin-top: 3.5vh;
}
</style>
